var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3162 15.304C58.1963 13.7892 57.6539 12.3385 56.7509 11.1165C55.8478 9.89452 54.6201 8.95026 53.2073 8.39096C51.7945 7.83166 50.2532 7.67974 48.7584 7.95244C47.2636 8.22514 45.8752 8.91154 44.7509 9.93369C43.6267 10.9558 42.8115 12.2728 42.3981 13.7349C41.9847 15.1971 41.9896 16.7459 42.4122 18.2054C42.8348 19.6649 43.6583 20.9767 44.789 21.9917C45.9197 23.0067 47.3124 23.6844 48.8089 23.9476L49.1475 28.2507C49.1898 28.7878 49.017 29.3196 48.6671 29.7293C48.3172 30.1389 47.819 30.3928 47.2819 30.4351L22.982 32.3475C22.445 32.3898 21.9131 32.217 21.5035 31.8671C21.0938 31.5172 20.84 31.019 20.7977 30.4819L20.459 26.1788C22.3291 25.5357 23.9005 24.2326 24.8785 22.5139C25.8566 20.7951 26.1742 18.7786 25.7719 16.8424C25.3695 14.9062 24.2749 13.1832 22.693 11.9963C21.1112 10.8095 19.1508 10.2403 17.1793 10.3955C15.2078 10.5506 13.3606 11.4195 11.9839 12.8392C10.6072 14.2589 9.79557 16.1319 9.70108 18.1072C9.60659 20.0825 10.2358 22.0245 11.4707 23.5691C12.7055 25.1137 14.4614 26.1549 16.409 26.4976L16.7477 30.8007C16.8745 32.4118 17.6362 33.9067 18.8651 34.9563C20.094 36.0059 21.6896 36.5243 23.3008 36.3975L33.4257 35.6007L37.4757 35.2819L47.6006 34.4851C49.2118 34.3583 50.7066 33.5966 51.7563 32.3677C52.8059 31.1387 53.3243 29.5432 53.1975 27.932L52.8588 23.6289C54.5614 23.0406 56.0208 21.9043 57.0083 20.3978C57.9959 18.8913 58.4559 17.0998 58.3162 15.304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2922 45.6623C41.8568 46.2863 44.688 49.2546 44.985 53.029C45.3371 57.5025 41.996 61.4144 37.5226 61.7665C33.0491 62.1185 29.1372 58.7775 28.7851 54.304C28.4881 50.5299 30.8197 47.1555 34.2423 45.9812L33.2659 33.5758L37.3159 33.257L38.2922 45.6623Z",
    fill: "url(#paint0_linear_7247_30401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7247_30401",
    x1: 35.2914,
    y1: 33.4164,
    x2: 37.5226,
    y2: 61.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefIcon);
export default __webpack_public_path__ + "static/media/refIcon.adeabac5e326962af70c122afa91ff6c.svg";
export { ForwardRef as ReactComponent };